export var COMBINE_ENCN_FLAG = "combine_encn_text";
export var DEFAULT_ENCN_BEHAVIOUR = false;
